export default {
  en: {
    tab: {
      curriculum: "Curriculum",
      newTeachingMethod: "New Teaching Method",
      thesisAdvising: "Thesis Advising",
      studentAdvising: "Student Advising",
    },
    list: {
      remrk: "Others",
      curriculum: {
        zTerm: "Semester",
        hakje: "Curriculum No",
        text1: "Title",
        hakju: "Credit",
        time2: "Hours",
        langu: "Language",
        teamT: "Team Teaching",
        penal: "Syllabus Update",
        avg: "Class Evaluation",
        totAvg: "College Average",
      },
      master: {
        zTerm: "Semester",
        degree: "M.S./Ph.D.",
        referee: "Chief/Assistant referee",
        graduateDiv: "Category",
        graduateNm: "Affiliated gradschool",
        totalnumber: "Number",
      },
      studentAdvising: {
        guidCd: "Classification",
        contents: "Contents",
        begEnd: "Period",
      },
    },
    detail: {},
    //임시 div
    div: {
      zero: "None",
      sca: "Student Club Advisor",
      seminar: "Freshman Seminar",
      notice: "Notice on Meeting Schedule(2 hours per week)",
      advising:
        "Academic Advising for Academic Warning Recipients and Risk Group Students",
    },
  },
  ko: {
    tab: {
      curriculum: "교육과정운영",
      newTeachingMethod: "신교육개발 및 기법 운영",
      thesisAdvising: "석박사배출실적",
      studentAdvising: "학생지도",
    },
    list: {
      remrk: "비고",
      curriculum: {
        zTerm: "학기",
        hakje: "학정번호",
        text1: "교과목명",
        hakju: "학점",
        time2: "실시간수",
        langu: "어학",
        teamT: "팀티칭",
        penal: "수업계획서 등재시기",
        avg: "강의 평가점수",
        totAvg: "대학 평가",
      },
      master: {
        zTerm: "학기",
        degree: "석사/박사",
        referee: "주심/부심",
        graduateDiv: "대학원 구분",
        graduateNm: "대학원 이름",
        totalnumber: "배출인원",
      },
      studentAdvising: {
        guidCd: "구분",
        contents: "내용",
        begEnd: "기간",
      },
    },
    detail: {},
    div: {
      sca: "동아리 및 학생단체 지도교수",
      seminar: "신입생 지도행사 참여",
      notice: "학기 중 주당 2시간의 면담시간 공지",
      advising: "학기 중 학사경고자 및 위험군 학생 상담",
    },
  },
};